import icons from '../../../../../world/spa/libs/icons';

const getWorldIcon = icons.getWorldIcon;

export default {
    namespaced: true,
    state: {
        indexHref: '/',
        appColor: '#ffc400'
    },
    getters: {
        HBTheme: state => {
            return {
                appImg: getWorldIcon('foodIcon'),
                appName: 'YourFood',
                appNameColor: "#ffc400",
                anm22AppsButton: false
            }
        }
    },
    mutations: {
    },
    actions: {
    }
}